import { Divider } from '@mantine/core';

export const DividerConfig = Divider.extend({
  defaultProps: {
    color: 'light.3',
  },
});
